import WelcomeBoxItem from './WelcomeBoxItem'

export default WelcomeBoxItem
